<div class="modal-header" *transloco="let t; prefix: 'parts.modals'">
  <h5 class="modal-title">{{ t('returnParts.title') }}</h5>
  <button
    type="button"
    class="btn-close"
    [attr.aria-label]="'common.close' | transloco"
    (click)="onCancel()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'parts.modals'">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="return-parts-form">
    @if (isReturnWorkPartOrderMode) {
      <div class="form-group">
        <label>{{ t('returnParts.workOrderNumber') }} <span class="required">*</span></label>
        <div class="work-order-search">
          <app-search
            [placeholder]="t('returnParts.searchWorkOrderPlaceholder')"
            [disabled]="isLoading"
            [searchTerm]="workOrderSearchTerm"
            (searchTermUpdated)="onSearchTermUpdate($event)"
            customWidth="100%">
          </app-search>

          @if (isWorkOrderSearchLoading || workOrders.length) {
            <div class="work-order-results">
              @if (isWorkOrderSearchLoading) {
                <div class="work-order-status">
                  <span class="spinner-border"></span>
                </div>
              } @else {
                <div class="work-order-results-scroll">
                  @for (workOrder of workOrders; track workOrder.id) {
                    <button
                      type="button"
                      class="work-order-result"
                      (click)="onSelectWorkOrder(workOrder, $event)">
                      <span>{{ workOrder.name }}</span>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="form-group">
      <label>{{ t('fields.partName') }} <span class="required">*</span></label>
      @if (isReturnWorkPartOrderMode) {
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <button
            type="button"
            class="form-control dropdown-toggle"
            ngbDropdownToggle
            [disabled]="!issuedParts.length || isIssuedPartsLoading">
            <div class="dropdown-value">
              <span [class.placeholder-text]="!selectedPart">
                {{ selectedPart ? selectedPart.partName : (isIssuedPartsLoading ? t('returnParts.loadingParts') : t('returnParts.selectPart')) }}
              </span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (part of issuedParts; track part.requestId) {
                <button
                  type="button"
                  class="btn btn-outline"
                  ngbDropdownItem
                  (click)="onSelectPart(part, $event)">
                  {{ part.partName }}
                </button>
              }
            </div>
          </div>
        </div>
      } @else {
        <input
          class="form-control"
          type="text"
          formControlName="partName"
          [placeholder]="isPartLoading ? t('placeholders.loadingPartName') : ''"
          [disabled]="true" />
      }
    </div>

    <div class="form-group">
      <label>{{ t('fields.partNumber') }} <span class="required">*</span></label>
      <input
        class="form-control"
        type="text"
        formControlName="partNumber"
        [placeholder]="isReturnWorkPartOrderMode ? t('returnParts.autoFilledOnPartSelection') : (isPartLoading ? t('placeholders.loadingPartNumber') : '')"
        [disabled]="true" />
    </div>

    @if (!isReturnWorkPartOrderMode) {
      <div class="form-group">
        <label>{{ t('fields.description') }}</label>
        <input
          class="form-control"
          type="text"
          formControlName="description"
          [disabled]="true" />
      </div>
    }

    @if (isReturnWorkPartOrderMode) {
      <div class="form-row">
        <div class="form-group half-width">
          <app-flatpickr-date-picker
            [label]="t('fields.date')"
            [required]="true"
            [value]="form.get('date')?.value"
            [dateFormat]="'Y-m-d'"
            (valueChange)="onDateChange($event)">
          </app-flatpickr-date-picker>
        </div>

        <div class="form-group half-width">
          <label>{{ t('returnParts.returnedBy') }} <span class="required">*</span></label>
          <div ngbDropdown class="custom-dropdown" [autoClose]="true">
            <button
              type="button"
              class="form-control dropdown-toggle"
              ngbDropdownToggle
              [disabled]="!assignedTechnicians.length || isTechniciansLoading">
              <div class="dropdown-value">
                <span [class.placeholder-text]="!selectedTechnician">
                  {{ selectedTechnician ? selectedTechnician.name : (isTechniciansLoading ? t('returnParts.loadingTechnicians') : t('returnParts.selectTechnician')) }}
                </span>
                <i class="ph ph-caret-down lh-base"></i>
              </div>
            </button>
            <div ngbDropdownMenu>
              <div class="d-flex flex-column">
                @for (technician of assignedTechnicians; track technician.id) {
                  <button
                    type="button"
                    class="btn btn-outline"
                    ngbDropdownItem
                    (click)="onSelectTechnician(technician, $event)">
                    {{ technician.name }}
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="form-group">
        <app-flatpickr-date-picker
          [label]="t('fields.date')"
          [required]="true"
          [value]="form.get('date')?.value"
          [dateFormat]="'Y-m-d'"
          (valueChange)="onDateChange($event)">
        </app-flatpickr-date-picker>
      </div>
    }

    <div class="form-row">
      <div class="form-group half-width">
        <label>{{ t('returnParts.quantityReturning') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input
              type="number"
              min="1"
              class="form-control dropdown-toggle"
              formControlName="quantityReturning"
              ngbDropdownToggle
              [placeholder]="t('placeholders.enterOrSelect')" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of quantityOptions; track option.value) {
                <button
                  type="button"
                  class="btn btn-outline"
                  ngbDropdownItem
                  (click)="onSelect('quantityReturning', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group half-width">
        <label>{{ isReturnWorkPartOrderMode ? t('returnParts.reasons') : t('returnParts.reason') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <button
            type="button"
            class="form-control dropdown-toggle"
            ngbDropdownToggle
            [disabled]="!returnReasons.length || isReturnReasonsLoading">
            <div class="dropdown-value">
              <span [class.placeholder-text]="!selectedReturnReason">
                {{ selectedReturnReason ? selectedReturnReason.name : (isReturnReasonsLoading ? t('returnParts.loadingReasons') : (isReturnWorkPartOrderMode ? t('returnParts.selectReason') : t('returnParts.enterReason'))) }}
              </span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (reason of returnReasons; track reason.id) {
                <button
                  type="button"
                  class="btn btn-outline"
                  ngbDropdownItem
                  (click)="onSelectReturnReason(reason, $event)">
                  {{ reason.name }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ t('fields.notes') }} @if (isReturnWorkPartOrderMode) { <span class="required">*</span> }</label>
      <textarea
        class="form-control notes"
        formControlName="notes"
        [placeholder]="t('placeholders.addNotes')">
      </textarea>
    </div>

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()">
        {{ 'common.cancel' | transloco }}
      </button>
      <button
        type="submit"
        class="save-btn"
        [disabled]="isLoading || isPartLoading || isWorkOrderSearchLoading || isIssuedPartsLoading || isTechniciansLoading || isReturnReasonsLoading || form.invalid || (isReturnWorkPartOrderMode && !selectedWorkOrder) || !selectedPart || (isReturnedByRequired && !selectedTechnician) || !selectedReturnReason">
        @if (isLoading) {
          <span class="spinner-border"></span>
        } @else {
          <span>{{ t('actions.save') }}</span>
        }
      </button>
    </div>
  </form>
</div>
